import { render, staticRenderFns } from "./Terms_new.vue?vue&type=template&id=32b7c240&scoped=true"
import script from "./Terms_new.vue?vue&type=script&lang=js"
export * from "./Terms_new.vue?vue&type=script&lang=js"
import style0 from "./Terms_new.vue?vue&type=style&index=0&id=32b7c240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b7c240",
  null
  
)

export default component.exports